import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { faBan } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.less']
})
export class TermsAndConditionsComponent implements OnInit {
  videoEnded = false;
  termsConditionsChecked = false;
  fontAwesomeBanIcon = faBan;
  player: any;

  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit() {
    this.init();
  }

  init() {
    var tag = document.createElement('script');
    tag.src = 'https://play.vidyard.com/embed/v4.js';
    tag.async = true;
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window['onVidyardAPI'] = (vidyardEmbed) => {
      vidyardEmbed.api.addReadyListener((_, player) => {
        this.player = player;
        player.on('playerComplete', () => {
          this.videoEnded = true;
          this.ref.detectChanges();
        });

      }, "kwofrcHUPvorVfA1zwJcXd")

    }
  }

  onVideoEnded() {
    this.videoEnded = true;
  }

  updateCheckboxStatus(checkBoxChecked) {
    this.termsConditionsChecked = checkBoxChecked;
  }

  sendActivationSuccess() {
    window.parent?.postMessage('MS_TEAMS_ACTIVATION_SUCCESS', '*');
  }

  sendActivationCancel() {
    this.player.pause();
    window.parent?.postMessage('MS_TEAMS_ACTIVATION_CANCEL', '*');
  }

  sendActivationFailure() {
    window.parent?.postMessage('MS_TEAMS_ACTIVATION_FAILURE', '*');
  }
}
